import e from "./index836.js";
import i from "./index839.js";
import a from "./index816.js";
function t(r) {
  return a(r) ? e(r, !0) : i(r);
}
export {
  t as default
};
